'use client';
import classes from './styles.module.scss';
import { Star } from '../../../../public/Images';
import Image from 'next/image';

const RatingStars = ({ rating }: { rating: number }) => {
    return (
        <div className={classes.container}>
            {Array.from(Array(rating).keys()).map((_, i) => (
                <Image
                    loading={'eager'}
                    src={Star.src}
                    width={Star.width}
                    height={Star.height}
                    key={i + 'SS'}
                    alt="rating star"
                />
            ))}
        </div>
    );
};

export default RatingStars;
